module.exports = __webpack_public_path__ + "static/media/srpn-1.5e96a44d.gif";